import { render, staticRenderFns } from "./raw_materials_list.vue?vue&type=template&id=5e56aa9a"
import script from "./raw_materials_list.vue?vue&type=script&lang=js"
export * from "./raw_materials_list.vue?vue&type=script&lang=js"
import style0 from "./raw_materials_list.vue?vue&type=style&index=0&id=5e56aa9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports